'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _getIterator2 = require('babel-runtime/core-js/get-iterator');

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _vuex = require('vuex');

var _PushCartItem = require('./PushCartItem');

var _PushCartItem2 = _interopRequireDefault(_PushCartItem);

var _Gifts = require('./Gifts');

var _Gifts2 = _interopRequireDefault(_Gifts);

var _types = require('./types');

var pushCartTypes = _interopRequireWildcard(_types);

var _functional = require('../../../utils/functional');

var _utils = require('../../../utils');

var _uuid = require('uuid');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/** @typedef {{ characterLimit: number; }} PersonalisationRules */

exports.default = {
  name: 'PushCart',

  data: function data() {
    return {
      isMounted: false,
      itemBeingAddedId: null,
      normalItemHeight: 170,
      windowHeight: window.innerHeight
    };
  },
  created: function created() {
    var _this = this;

    document.body.addEventListener('submit', function () {
      var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(e) {
        var form, submitButton, uuid, formData, id, quantity, properties, personalisationVariantId, personalisationRules;
        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!e.defaultPrevented) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt('return');

              case 2:
                form = e.target;

                if (!form.matches('.js-AddToCart')) {
                  _context.next = 30;
                  break;
                }

                e.preventDefault();

                submitButton = (0, _functional.getElement)('[type=submit]', { context: form });

                if (!submitButton.classList.contains('js-AddToCart_Submit-disabled')) {
                  _context.next = 8;
                  break;
                }

                return _context.abrupt('return');

              case 8:
                uuid = (0, _uuid.v4)();
                formData = new FormData(form);
                id = Number(formData.get('id'));
                quantity = Number(formData.get('quantity'));
                properties = (0, _functional.buildProperties)(formData);
                personalisationVariantId = form.dataset.personalisationProduct;


                _this.itemBeingAddedId = id;

                if (!personalisationVariantId) {
                  _context.next = 23;
                  break;
                }

                _context.next = 18;
                return fetch(window.location.pathname + '?view=personalisation-validation').then(function (response) {
                  return response.json();
                });

              case 18:
                personalisationRules = _context.sent;

                if (!(properties['Your Text'].length > personalisationRules.characterLimit)) {
                  _context.next = 22;
                  break;
                }

                e.preventDefault();
                return _context.abrupt('return');

              case 22:

                properties['__Child uid'] = uuid;

              case 23:
                _context.next = 25;
                return _this.localAddItemToCart({
                  id: id,
                  properties: properties,
                  quantity: quantity
                });

              case 25:
                if (!personalisationVariantId) {
                  _context.next = 28;
                  break;
                }

                _context.next = 28;
                return _this.localAddItemToCart({
                  id: parseInt(personalisationVariantId, 10),
                  properties: {
                    '__Parent uid': uuid,
                    '_type': 'Personalisation'
                  },
                  quantity: quantity
                });

              case 28:

                window.drawers.activeDrawerKey = 'cart';

                _this.itemBeingAddedId = null;

              case 30:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }));

      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }());

    document.body.addEventListener('click', function () {
      var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2(e) {
        var target, variantId, uuid, discountString;
        return _regenerator2.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                target = e.target;


                if (target.matches('.js-ProductCard_Value')) {
                  variantId = parseInt(target.dataset.variantId, 10);
                  uuid = (0, _uuid.v4)();


                  _this.localAddItemToCart({
                    id: variantId,
                    properties: {
                      '__Child uid': uuid
                    },
                    quantity: 1
                  });
                }

                if (target.matches('.js-ApplyDiscount')) {
                  e.stopPropagation();
                  e.preventDefault();

                  discountString = _this.initialData.discount.string;


                  if (discountString) {
                    if (!window.localStorage.getItem('baoDiscountApplied')) {
                      fetch(discountString).then(function (response) {
                        if (response.ok) {
                          window.localStorage.setItem('baoDiscountApplied', 'true');

                          target.style.display = 'none';
                          var discountMessage = (0, _functional.getElement)('.js-DiscountMessage');
                          discountMessage.classList.add('crt-Push_DiscountMessage-show');
                        }
                      });
                    }
                  }
                }

              case 3:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this);
      }));

      return function (_x2) {
        return _ref2.apply(this, arguments);
      };
    }());

    var resizeFnc = function resizeFnc() {
      return _this.windowHeight = window.innerHeight;
    };
    window.addEventListener('resize', (0, _utils.debounce)(resizeFnc, 50));

    document.body.addEventListener('click', function () {
      var _ref3 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee3(e) {
        var target, selectedItemsContent, selectedItems, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, item;

        return _regenerator2.default.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                target = e.target;

                if (!target.matches('.js-AddMultiToCartButton')) {
                  _context3.next = 30;
                  break;
                }

                selectedItemsContent = target.parentElement.querySelector('[data-graphenehc-multibuy-carousel-external-el]').getAttribute('data-graphene-carousel-selected-items');
                selectedItems = JSON.parse(selectedItemsContent || '[]');
                _iteratorNormalCompletion = true;
                _didIteratorError = false;
                _iteratorError = undefined;
                _context3.prev = 7;
                _iterator = (0, _getIterator3.default)(selectedItems);

              case 9:
                if (_iteratorNormalCompletion = (_step = _iterator.next()).done) {
                  _context3.next = 16;
                  break;
                }

                item = _step.value;
                _context3.next = 13;
                return _this.localAddItemToCart({
                  id: item.id,
                  quantity: item.quantity
                });

              case 13:
                _iteratorNormalCompletion = true;
                _context3.next = 9;
                break;

              case 16:
                _context3.next = 22;
                break;

              case 18:
                _context3.prev = 18;
                _context3.t0 = _context3['catch'](7);
                _didIteratorError = true;
                _iteratorError = _context3.t0;

              case 22:
                _context3.prev = 22;
                _context3.prev = 23;

                if (!_iteratorNormalCompletion && _iterator.return) {
                  _iterator.return();
                }

              case 25:
                _context3.prev = 25;

                if (!_didIteratorError) {
                  _context3.next = 28;
                  break;
                }

                throw _iteratorError;

              case 28:
                return _context3.finish(25);

              case 29:
                return _context3.finish(22);

              case 30:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this, [[7, 18, 22, 30], [23,, 25, 29]]);
      }));

      return function (_x3) {
        return _ref3.apply(this, arguments);
      };
    }());
  },
  mounted: function mounted() {
    var _this2 = this;

    window.addEventListener('pushcartOpened', function () {
      _this2.loadGraphene();
    });

    this.isMounted = true;
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('pushcartOpened', this.loadGraphene);
  },


  computed: (0, _assign2.default)({}, (0, _vuex.mapGetters)({
    initialData: pushCartTypes.GET_INITIAL_DATA,
    itemCount: pushCartTypes.GET_ITEM_COUNT,
    lineItems: pushCartTypes.GET_LINE_ITEMS,
    loading: pushCartTypes.GET_LOADING,
    subtotal: pushCartTypes.GET_SUBTOTAL,
    giftThreshold: pushCartTypes.GET_GIFT_THRESHOLD,
    giftInitiallyOpen: pushCartTypes.GET_GIFT_INITIALLY_OPEN
  }), {
    deliveryMessage: function deliveryMessage() {
      var subtotal = this.subtotal;
      var isInFirstTier = subtotal >= this.initialData.delivery.firstTier.minimum && subtotal <= this.initialData.delivery.firstTier.maximum;
      var isInSecondTier = subtotal >= this.initialData.delivery.secondTier.minimum && subtotal <= this.initialData.delivery.secondTier.maximum;

      if (isInSecondTier) {
        return this.initialData.delivery.secondTier.message;
      } else if (isInFirstTier) {
        return this.initialData.delivery.firstTier.message.replace('[amount]', (0, _functional.formatMoney)(this.initialData.delivery.secondTier.minimum - subtotal));
      }
    },
    isNewItemBeingAdded: function isNewItemBeingAdded() {
      var _this3 = this;

      return this.itemBeingAddedId != null && this.lineItems.some(function (lineItem) {
        return lineItem.id === _this3.itemBeingAddedId;
      }) === false;
    },
    scrollableHeight: function scrollableHeight() {
      return this.isMounted && this.$refs.topBar && this.$refs.footer && this.windowHeight - this.$refs.topBar.offsetHeight - this.$refs.footer.offsetHeight;
    },
    shouldShowGifts: function shouldShowGifts() {
      return this.subtotal >= this.giftThreshold;
    },
    showPromotedProduct: function showPromotedProduct() {
      var _this4 = this;

      return this.initialData.promoted.enabled && !this.lineItems.some(function (lineItem) {
        return lineItem.variant_id === _this4.initialData.promoted.productId;
      });
    },
    showGrapheneHC: function showGrapheneHC() {
      return this.initialData.grapheneHC.enabled;
    },
    lastAddedProductID: function lastAddedProductID() {
      if (this.lineItems.length > 0) {
        return String(this.lineItems[0].product_id);
      }
      return null;
    },
    showDiscount: function showDiscount() {
      return this.initialData.discount.enabled;
    },
    showDiscountButton: function showDiscountButton() {
      return !window.localStorage.getItem('baoDiscountApplied');
    },
    showDiscountAppliedMessage: function showDiscountAppliedMessage() {
      return window.localStorage.getItem('baoDiscountApplied');
    }
  }),

  watch: {
    itemCount: function itemCount(val) {
      var elements = (0, _functional.getElements)('[data-cart-count]');
      if (val === 0) {
        elements.forEach(function (el) {
          el.style.display = 'none';
        });
      } else {
        elements.forEach(function (el) {
          el.style.display = 'flex';
          el.textContent = val;
        });
      }
    },


    'lineItems.length': function lineItemsLength(newVal, oldVal) {
      // Check if the cart is open and if there's at least one item in the cart
      if (newVal > 0 && newVal !== oldVal) {
        this.loadGraphene();
      }
    }
  },

  methods: (0, _assign2.default)({}, (0, _vuex.mapActions)({
    addItemToCart: pushCartTypes.ACTION__ADD_ITEM_TO_CART,
    removeAllItems: pushCartTypes.ACTION__REMOVE_ALL_ITEMS
  }), {

    formatMoney: _functional.formatMoney,

    localAddItemToCart: function () {
      var _ref5 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee4(_ref4) {
        var id = _ref4.id,
            properties = _ref4.properties,
            quantity = _ref4.quantity;
        return _regenerator2.default.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                this.itemBeingAddedId = id;

                // If we are on the cart page, we don't want to trigger the drawer to open.
                if (window.location.pathname !== '/cart') {
                  window.drawers.activeDrawerKey = 'cart';
                }

                _context4.next = 4;
                return this.addItemToCart({ id: id, properties: properties, quantity: quantity });

              case 4:

                this.itemBeingAddedId = null;

              case 5:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function localAddItemToCart(_x4) {
        return _ref5.apply(this, arguments);
      }

      return localAddItemToCart;
    }(),
    loadGraphene: function loadGraphene() {
      if (this.showGrapheneHC && this.lastAddedProductID != null) {
        $g.load({
          page_context: {
            currency_id: window.Shopify.country,
            product_id: this.lastAddedProductID
          },
          elements: [{ id: 'push_cart', target: '.crt-GrapheneHC' }]
        });
      }
    }
  }),

  components: {
    PushCartItem: _PushCartItem2.default,
    Gifts: _Gifts2.default
  }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//